import BlogDetailsComponent from "./BlogDetailsComponent";

export default BlogDetailsComponent;
